module.exports = __webpack_public_path__ + "static/media/slick.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.ttf
// module id = 859
// module chunks = 3